export default __webpack_public_path__ + "static/media/001-muscles.38bd95ae.svg";